/**
 * Batches contiguous data-progress parts from corporate-family-tree together.
 * Returns an array where each item is either:
 * - A single non-progress part
 * - An array of contiguous progress parts with source='corporate-family-tree'
 *
 * @example
 * Input: [text, progress(cft), progress(cft), tool, progress(cft)]
 * Output: [
 *   { type: 'single', part: text },
 *   { type: 'progress-batch', parts: [progress, progress] },
 *   { type: 'single', part: tool },
 *   { type: 'progress-batch', parts: [progress] }
 * ]
 */ export function batchMessageParts(parts) {
    const batched = [];
    let currentBatch = [];
    for (const part of parts){
        // Check if this is a corporate-family-tree progress event
        if (part.type === 'data-progress') {
            currentBatch.push(part);
        } else {
            // Flush current batch if it exists
            if (currentBatch.length > 0) {
                batched.push({
                    type: 'progress-batch',
                    parts: currentBatch
                });
                currentBatch = [];
            }
            batched.push({
                type: 'single',
                part
            });
        }
    }
    // Flush remaining batch
    if (currentBatch.length > 0) {
        batched.push({
            type: 'progress-batch',
            parts: currentBatch
        });
    }
    return batched;
}
